export var FilterType;
(function (FilterType) {
    FilterType["BASE_FILTER"] = "BASE_FILTER";
    FilterType["SUBMITABLE_FILTER"] = "SUBMITABLE_FILTER";
    FilterType["DEPARTURE_AIRPORT_FILTER"] = "DEPARTURE_AIRPORT_FILTER";
    FilterType["DESTIATION_FILTER"] = "DESTIATION_FILTER";
    FilterType["CHECK_BOX_FILTER"] = "CHECK_BOX_FILTER";
    FilterType["CHECK_BOX_GROUP_FILTER"] = "CHECK_BOX_GROUP_FILTER";
    FilterType["CHECK_BOX_HYBRID_GROUP_FILTER"] = "CHECK_BOX_HYBRID_GROUP_FILTER";
    FilterType["SELECT_FILTER"] = "SELECT_FILTER";
    FilterType["RATING_FILTER"] = "RATING_FILTER";
    FilterType["DATE_PICKER_FILTER"] = "DATE_PICKER_FILTER";
    FilterType["RADIO_GROUP_FILTER"] = "RADIO_GROUP_FILTER";
    FilterType["SLIDER_FILTER"] = "SLIDER_FILTER";
    FilterType["SWITCH_FILTER"] = "SWITCH_FILTER";
})(FilterType || (FilterType = {}));
